<template>
  <div class="copyabletext-container">
    <div class="copyable-text" :class="{pulse: copyAnimation}">
      <slot></slot>
    </div>
    <input type="hidden" :value="data" ref="datafield"/>
    <div class="copy-icon" @click.stop="copyToClipboard()">
      <i class="far fa-clone copy-icon"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CopyableText',
  props: {
    data: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      copyAnimation: false
    }
  },
  methods: {
    copyToClipboard() {
      // const copy = document.getElementById("dataField")
      let copy = this.$refs.datafield
      copy.setAttribute('type', 'text') 
      copy.select()
      document.execCommand("copy");
      copy.setAttribute('type', 'hidden') 
      this.copyAnimation = true
      setTimeout(() => this.copyAnimation = false, 1000)
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared.scss';

.copyable-text {
  display: inline-block;
}
.copy-icon {
  cursor: pointer;
  margin-left: 8px;
  color: $primary;
  float: right;
}
</style>